import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbThemeService, NbToastrService } from '@nebular/theme';

import { Subject, Subscription, timer } from 'rxjs';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { HeaderTitleService } from '@app/@core/services/header-title.service';
import { QuickBooksService } from '@app/@core/services/quickbooks.service';
import { AppState } from '@app/app.module';
import { Store } from '@ngrx/store';
import  moment from 'moment';
import { first } from 'rxjs/operators';
import { TenantService } from '@app/@core/services/tenant.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'ngx-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  title: string = '';
  user: any;
  isUseQuickBook = false;
  isQuickBookExpired = false;
  isResync = false;
  isLoading = false;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [
    { title: 'Change Password', link: 'auth/change-password' },
    { title: 'Log out', link: 'auth/logout' },
  ];

  constructor(private themeService: NbThemeService,
    private authService: NbAuthService,
    private headerTitleSerice: HeaderTitleService,
    private quickbooksService: QuickBooksService,
    private store: Store<AppState>,
    private tenantService: TenantService,
    private toastrService: NbToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router) {

    this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {
        if (token.isValid()) {
          this.user = token.getPayload();
        }
      });

    this.subscription = this.headerTitleSerice.getTitle().subscribe(title => {
      this.title = title;
    });

    this.store.select(x => x.tenantSetting).subscribe(data => {
      if (data) {
        this.isUseQuickBook = data.isUseQuickBook;
        this.isQuickBookExpired = data.quickBookExpiredTime ? moment(data.quickBookExpiredTime).isBefore(moment().utc()) : true;
      }

    })

    this.activatedRoute.fragment.pipe(first()).subscribe(value => {
      if (value != 'delay') {
        this.tenantService.isResyncQuickbook().subscribe((res: any) => {
          this.isResync = res;
        })
      }
      this.router.navigate([]);
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  connect() {
    window.location.href = this.quickbooksService.getConnectUrl(window.location.href);
  }

  resync() {
    this.isLoading = true;
    this.tenantService.resyncQuickbook().subscribe(res => {
      this.isResync = false;
      this.toastrService.success("", "Your data is synced!")
      this.isLoading = false;
    });
  }
}
